import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, PLATFORM_ID} from '@angular/core'
import {Level} from './sidenav.types'
import {isPlatformBrowser} from '@angular/common'

@Component({
  selector: 'cft-holy-grail-grid-sidenav-submenu',
  template: `
    <ul class="relative flex-1 space-y-xs">
      @for (l of levels; track l.label) {
        <li
          #levelListItem
          cft-holy-grail-grid-sidenav-submenu-item
          [path]="l.path"
          [label]="l.label"
          (hideSubMenu)="hideSubMenu()"
          (showSubMenu)="showSubMenu(levelListItem.element.nativeElement.offsetTop, l)"
        ></li>
      }
    </ul>
    @if (showSubLevelMenu?.level) {
      <cft-holy-grail-grid-sidenav-list
        class="absolute right-0 -mr-[300px] max-h-96 w-[300px] overflow-y-scroll bg-grey-50 px-sm py-xs"
        [style.top.px]="showSubLevelMenu?.top ?? 0"
        (mouseenter)="showSubMenu(showSubLevelMenu?.top ?? 0)"
        (mouseleave)="hideSubMenu()"
      >
        @for (i of showSubLevelMenu?.level?.items; track i) {
          <li cft-holy-grail-grid-sidenav-list-item [label]="i.label" [path]="i.path"></li>
        }
      </cft-holy-grail-grid-sidenav-list>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../../styles/theme.css';

    :host {
      @apply relative flex;
    }
  `,
  standalone: false,
})
export class HolyGrailGridSidenavSubmenuComponent {
  @Input() levels: Level[] = []

  protected showSubLevelMenu?: {top: number; level?: Level}
  private hideMenuTimeoutRef?: number

  constructor(
    private readonly cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private readonly platformId,
  ) {}

  showSubMenu(top: number, level?: Level) {
    if (!isPlatformBrowser(this.platformId)) return

    if (this.hideMenuTimeoutRef) {
      window.clearTimeout(this.hideMenuTimeoutRef)
      this.hideMenuTimeoutRef = undefined
    }

    this.showSubLevelMenu = level ? {top, level} : this.showSubLevelMenu
  }

  hideSubMenu() {
    if (!isPlatformBrowser(this.platformId)) return

    this.hideMenuTimeoutRef = window.setTimeout(() => {
      this.showSubLevelMenu = undefined
      this.cdr.markForCheck()
    }, 300)
  }
}
